import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AgencyBuilder } from '../builders/agency-builder';
import { ApiService } from './api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
export class AgenciesApiService {
    constructor(authenticatedApi, unauthenticatedApi) {
        this.authenticatedApi = authenticatedApi;
        this.unauthenticatedApi = unauthenticatedApi;
    }
    getAgency() {
        return this.authenticatedApi.get('/agency').toPromise().then(response => {
            return AgencyBuilder.buildAgency(response.agency);
        });
    }
    requestNewPassword(email) {
        return this.unauthenticatedApi.get('/agency/password_recovery', { email })
            .toPromise().then(response => response);
    }
    changePassword(currentPassword, newPassword, resetCode) {
        let payload = {
            current: currentPassword,
            new: newPassword,
            code: resetCode
        };
        return this.authenticatedApi.post('/agency/password', JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    resetPassword(newPassword, resetCode) {
        let payload = {
            password: newPassword,
            code: resetCode
        };
        return this.unauthenticatedApi.post('/agency/reset_password', JSON.stringify(payload))
            .toPromise().then(response => response);
    }
}
AgenciesApiService.ɵfac = function AgenciesApiService_Factory(t) { return new (t || AgenciesApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService)); };
AgenciesApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AgenciesApiService, factory: AgenciesApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AgenciesApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }]; }, null); })();
//# sourceMappingURL=agencies-api.service.js.map